<template>
  <section class="section" id="contacts">
    <div class="container">
      <div class="row mt-60">
        <div class="col-m-5">
          <div class="contacts">
            <div class="contacts__sub">Контакты</div>
            <div class="contacts__title">Чем мы можем помочь вам?</div>
            <ul class="contacts__data">
              <li>
                <a href="mailto:welcome@giveandgo.ru">welcome@giveandgo.ru</a>
              </li>
              <li>
                <a href="tel:+79062106621">+7 906 21 066 21</a><span> (<a href="https://wa.me/79062106621" target="_blank">Whatsapp</a>,
                  <a href="tg://resolve?domain=vitaly_m" target="_blank">Telegram</a>,
                  <a href="viber://add?number=79062106621" target="_blank">Viber</a>)</span>
              </li>
            </ul>
            <div class="contacts__qr">
              <img :src="require('@/assets/img/qr.jpg')" />
              <span>Наведите камеру смартфона на код, чтобы связаться с нами и получить консультацию</span>
            </div>
          </div>
        </div>
        <div class="col-m-7">
          <Feedback />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Feedback from '@/components/Feedback.vue'

const name = 'VueFooter'

export default {
  name,
  components: {
    Feedback
  }
}

</script>
